import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    users: [],
    totalUsers: 0,
    userDetails: null,
    walletDetails: null,
    userTransactions: null,
    userPendingTransactions: null,
    userVisaTransactions: null,
    userPaymentMethods: null,
  },
  getters: {
    getUsers: state => state.users,
    getTotalUsers: state => state.totalUsers,
    getUserDetails: state => state.userDetails,
    getWalletDetails: state => state.walletDetails,
    getUserTransactions: state => state.userTransactions,
    getUserPendingTransactions: state => state.userPendingTransactions,
    getUserVisaTransactions: state => state.userVisaTransactions,
    getUserPaymentMethods: state => state.userPaymentMethods,
  },
  mutations: {
    SET_USERS: (state, list) => {
      state.users = list
    },
    SET_TOTAL_USERS: (state, total) => {
      state.totalUsers = total
    },
    SET_USER_DETAILS: (state, user) => {
      state.userDetails = user
    },
    SET_USER_WALLET: (state, wallet) => {
      state.walletDetails = wallet
    },
    SET_USER_TRANSACTIONS: (state, transactions) => {
      state.userTransactions = transactions
    },
    SET_USER_PENDING_TRANSACTIONS: (state, pendingTransactions) => {
      state.userPendingTransactions = pendingTransactions
    },
    SET_USER_VISA_TRANSACTIONS: (state, visaTransactions) => {
      state.userVisaTransactions = visaTransactions
    },
    SET_USER_PAYMENT_METHODS: (state, paymentMethods) => {
      state.userPaymentMethods = paymentMethods
    },
  },
  actions: {
    async fetchUsers({ commit }, queryParams) {
      let res
      try {
        commit('SET_USERS', [])
        res = await axiosIns.get('/users', {
          params: queryParams,
          timeout: 3000,
        })
        commit('SET_USERS', res.data.data.users)
        commit('SET_TOTAL_USERS', res.data.data.total)
      } catch (error) {
        console.log(error)
      }
      return res
    },
    updateUser(_, { data, userId }) {
      return axiosIns.patch(`users/${userId}`, data)
    },
    async getUserPicture(_, userId) {
      const pic = (await axiosIns.get(`/users/${userId}/picture`)).data.data.url
      return pic
    },
    async fetchUserDetails({ commit }, userId) {
      commit('SET_USER_DETAILS', null)
      const res = await axiosIns.get(`/users/${userId}`)
      commit('SET_USER_DETAILS', res.data.data)
      return res
    },
    async fetchUserWallet({ commit }, userId) {
      commit('SET_USER_WALLET', null)
      const res = await axiosIns.get(`users/${userId}/wallet`)
      commit('SET_USER_WALLET', res.data.data)
      return res
    },
    async fetchUserTransactions({ state, commit }, params = { page: 1, size: 10 }) {
      try {
        commit('SET_USER_TRANSACTIONS', null)
        const res = await axiosIns.get(`users/wallet/${state.walletDetails.id}/transactions`, {
          params,
        })
        commit('SET_USER_TRANSACTIONS', res.data.data)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchUserPendingTransactions({ state, commit }, params = { page: 1, size: 10 }) {
      commit('SET_USER_PENDING_TRANSACTIONS', null)
      const res = await axiosIns.get(`users/wallet/${state.walletDetails.id}/pending-transactions`, {
        params,
      })
      commit('SET_USER_PENDING_TRANSACTIONS', res.data.data)
      return res
    },
    async fetchUserVisaTransactions({ state, commit }) {
      commit('SET_USER_VISA_TRANSACTIONS', null)
      const res = await axiosIns.get(`payments/transactions/wallets/${state.walletDetails.id}`)
      commit('SET_USER_VISA_TRANSACTIONS', res.data.data)
      return res
    },
    async fetchPaymentMethods({ commit }, id) {
      commit('SET_USER_PAYMENT_METHODS', null)
      const res = await axiosIns.get(`/payments/methods/external/${id}`)
      commit('SET_USER_PAYMENT_METHODS', res.data.data)
      return res
    },
    async addUserTransaction(_, { transaction, id }) {
      return new Promise((resolve, reject) => {
        axiosIns.post(`users/wallets/transactions/${id}`, transaction)
          .then(res => resolve(res))
          .catch(err => reject(err))
      })
    },
    async addUserPendingTransaction(_, transaction) {
      return new Promise((resolve, reject) => {
        axiosIns.post('users/wallets/pending-transactions', transaction)
          .then(res => resolve(res))
          .catch(err => reject(err))
      })
    },
    async fetchUserTripsList(_, params) {
      return axiosIns.get('/trips', {
        params,
      })
    },
    fetchLastOtp(_, phone) {
      return axiosIns.get('users/last-otp', {
        params: {
          phone,
        },
      })
    },

    async fetchUserDevices(_, { id }) {
      return (await axiosIns.get(`users/${id}/devices`)).data.data
    },
    createUserDeviceInfo(_, { id, deviceId, data }) {
      return axiosIns.post(`users/${id}/devices/${deviceId}`, data)
    },
    patchUserDeviceInfo(_, { id, deviceId, data }) {
      return axiosIns.patch(`users/${id}/devices/${deviceId}`, data)
    },

    async fetchUserPhones(_, { id }) {
      return (await axiosIns.get(`users/${id}/phones`)).data.data
    },
    createUserPhoneInfo(_, { id, data }) {
      return axiosIns.post(`users/${id}/phones/${data.phone_number}`, data)
    },
    patchUserPhoneInfo(_, { id, data }) {
      return axiosIns.patch(`users/${id}/phones/${data.phone_number}`, data)
    },
    blockDevice(_, { id, deviceId }) {
      return axiosIns.patch(`users/${id}/devices/${deviceId}/block`)
    },

  },
}
